import { Component, OnInit } from '@angular/core';
import {Account} from '@app/types/account';
import {PpApiGatewayService} from '@app/pp-api-gateway.service';
import {UserService} from '@app/user.service';

@Component({
  selector: 'pp-account-list',
  templateUrl: './account-list.component.html',
  styleUrls: ['./account-list.component.scss']
})
export class AccountListComponent implements OnInit {

  xhrInProgress = true;
  hasError = false;
  accounts: Array<Account>;

  constructor(
    private ppApiGateway: PpApiGatewayService,
    private userService: UserService
  ) { }

  ngOnInit() {
    this.ppApiGateway
    .getAccountsByContactId(this.userService.contactId)
    .subscribe(
      (accounts) => {
        this.accounts = accounts;
        this.xhrInProgress = false;
      },
      (err) => {
        console.error(err);
        this.xhrInProgress = false;
        this.hasError = true;
      }
    );
  }

}
